import { render, staticRenderFns } from "./AcknowledgementCard.vue?vue&type=template&id=bd64a2da&"
import script from "./AcknowledgementCard.vue?vue&type=script&lang=js&"
export * from "./AcknowledgementCard.vue?vue&type=script&lang=js&"
import style0 from "./AcknowledgementCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
